<template>
  <header class="card_title" :class="[{'end': isShowClose}, {'no-border': isNoBorder}]">
    <p class="text_color_primary text-16-M">
      {{ title }}
    </p>
    <i @click="close" v-if="isShowClose" class="iconfont iconshanchu close"></i>
  </header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowClose: {
      type: Boolean,
      default: false
    },
    isNoBorder: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
  .end {
    display: flex;
    justify-content: space-between;
  }
  .close {
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      color: $color-primary;
    }
  }
  .no-border {
    border: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/border-title.vue